import moment from 'moment'

export const prepareDate = (date) => moment(date).format("YYYY-MM-DD")

export const prepareDateTime = (date) => moment(date).format("YYYY-MM-DD HH:mm")

export const objectToURLParams = (obj) => Object.entries(obj).map(([key, val]) => `${key}=${val}`).join('&')

export const outputFile = function (filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', window.URL.createObjectURL(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export const s2ab = (s) => {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

export const empty = (val) => val === '' || val === null

export const isDateExpired = (date) => {
  if (date) {
    let today = new Date()
    let expiry = typeof date === 'string' ? new Date(date) : date
    expiry = expiry.setHours(23, 59, 59, 0)
    return today.getTime() >= expiry
  } else return false
}

export const UTC = (date) => {
  let dateObj = new Date(date)
  return dateObj.getTime()
}

export const userDetail = function (employeeId) {
  this.$router.push({name: 'employeeDetail', params: {employeeId: employeeId}})
}

export const isDayEqual = (date1, date2) => {
  let d1 = new Date(date1).setHours(0, 0, 0, 0)
  let d2 = new Date(date2).setHours(0, 0, 0, 0)
  return d1 === d2
}

export const debounce = (f, ms) => {
  let timer = null
  return function (...args) {
    const onComplete = () => {
      f.apply(this, args);
      timer = null;
    }
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(onComplete, ms);
  }
}

export const deleteObjectKeysByValue = (object, value) => {
  let clearObject = {...object}
  for (let k in clearObject) {
    if (clearObject[k] === value) delete clearObject[k]
  }
  return clearObject
}

export const documentDetail = function (documentId, category) {
  let docflowRoutes = {
    incoming: 'docflowIncomingDetail',
    outgoing: 'docflowOutgoingDetail',
    appeal: 'docflowAppealDetail'
  }
  this.$router.push({
    name: docflowRoutes[category],
    params: {documentId}
  })
}

export const assignmentDetail = function (documentId) {
  this.$router.push({
    name: 'documentDetail',
    params: {documentId}
  })
}

export const taskDetail = function (taskId, documentId) {
  this.$router.push({
    name: 'taskDetail',
    params: {taskId, documentId}
  })
}

export const objectSize = function (obj) {
  let size = 0, key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
}
